'use client';

import dynamic from 'next/dynamic';

import ReactWebsiteSettingsProvider from 'hooks/useWebsiteSettingsProvider';
import { ReactQueryClientProvider } from 'hooks/useReactQuery';
import { ReactCurrencyContextProvider } from 'hooks/useCurrencyContextProvider';
import { ReactFeatureToggleProvider } from 'hooks/useFeatureToggleProvider';
import { ReactLocalizationProvider } from 'hooks/useLocalizationProvider';
import DataContextProvider from 'context/DataContext';
import UpsellContextProvider from 'context/UpsellContext';
import { SearchValuesProvider } from 'context/SearchValuesContext';

const RootStylesWrapper = dynamic(
  () => import('components/RootStylesWrapper'),
  { ssr: false }
);

const AnalyticsProvider = dynamic(
  () => import('analytics').then((mod) => ({ default: mod.AnalyticsProvider })),
  { ssr: false }
);

const GoogleMapDialogProvider = dynamic(
  () => import('hooks/useGoogleMapProvider'),
  { ssr: false }
);

// BrowserRouter conflicts with Next.js routing but some components still use it
const BrowserRouterProvider = dynamic(
  () => import('hooks/useBrowserRouterProvider'),
  { ssr: false }
);

const Providers = ({ children, locale }) => {
  return (
    <ReactLocalizationProvider language={locale}>
      <ReactQueryClientProvider>
        {/* TODO: remove react-router-dom usage, remove BrowserRouterProvider */}
        <BrowserRouterProvider>
          <ReactFeatureToggleProvider>
            <ReactWebsiteSettingsProvider>
              <ReactCurrencyContextProvider>
                <RootStylesWrapper>
                  <DataContextProvider>
                    <UpsellContextProvider>
                      <SearchValuesProvider>
                        <AnalyticsProvider>
                          <GoogleMapDialogProvider>
                            {children}
                          </GoogleMapDialogProvider>
                        </AnalyticsProvider>
                      </SearchValuesProvider>
                    </UpsellContextProvider>
                  </DataContextProvider>
                </RootStylesWrapper>
              </ReactCurrencyContextProvider>
            </ReactWebsiteSettingsProvider>
          </ReactFeatureToggleProvider>
        </BrowserRouterProvider>
      </ReactQueryClientProvider>
    </ReactLocalizationProvider>
  );
};

export default Providers;
